import { RouteProps } from "react-router";
import { connect } from "react-redux";
import { RootState } from "src/ipm-shared/store/model/reducers";
import * as actions from "src/bepaid/store/model/Fetch/actions";
import * as selectors from "src/bepaid/store/model/Fetch/selectors";

import Component from "./View";

const mapStateToProps = (state: RootState) => ({
  platform: selectors.getPlatform(state),
  isFirstFetchDataFetch: selectors.getFirstFetchDataByKey(state)(
    "fetch_activities"
  ),
  isFirstFetchDataPay: selectors.getFirstFetchDataByKey(state)(
    "pay_activities"
  ),
  payFetchRecentActivities: selectors.getPayFetchRecentActivities(state)
});

const mapDispatchToProps = {
  getInvoiceRecentActivities: actions.getInvoiceRecentActivities,
  getPaymentRecentActivities: actions.getPaymentRecentActivities
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteProps;

export default connect(mapStateToProps, mapDispatchToProps)(Component);
